import { render } from "./AddCategory.vue?vue&type=template&id=bd3389c8"
import script from "../js/add-category.js?vue&type=script&lang=js"
export * from "../js/add-category.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__